export default "__VITE_ASSET__exB4X6rg__"